module.exports = {
    possibleTypos: {
        '@gnail': '@gmail',
        '.con': '.com'
    }
};
